import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f77caea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "JobBoard footer-white-after grid padded" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "debug",
  "data-scroll-section": ""
}, null, -1))
const _hoisted_3 = {
  class: "JobBoard__Right",
  "data-sticky-container": "",
  "data-scroll-section": ""
}
const _hoisted_4 = {
  key: 1,
  class: "JobBoard__Empty",
  "data-scroll-section": ""
}
const _hoisted_5 = { class: "picture" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", { srcset: "/images/job-board/empty.png 1x, /images/job-board/empty@2x.png 2x" }, null, -1))
const _hoisted_7 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobBoardForm = _resolveComponent("JobBoardForm")!
  const _component_JobBoardList = _resolveComponent("JobBoardList")!
  const _component_JobBoardItem = _resolveComponent("JobBoardItem")!
  const _component_StickyElement = _resolveComponent("StickyElement")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_JobBoardForm, {
      "data-scroll-section": "",
      onChange: _ctx.onChange
    }, null, 8, ["onChange"]),
    (_ctx.jobPage?.jobs.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_JobBoardList, {
            "data-scroll-section": "",
            id: "jobBoardList",
            selectedJob: _ctx.job,
            onLoadMore: _ctx.onLoadMore
          }, null, 8, ["selectedJob", "onLoadMore"]),
          _createElementVNode("article", _hoisted_3, [
            _createVNode(_component_StickyElement, { class: "JobBoard__Right__Sticky" }, {
              default: _withCtx(() => [
                _createVNode(_component_JobBoardItem)
              ]),
              _: 1
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("picture", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("img", {
              src: "/images/job-board/empty.png",
              alt: _ctx.$t('jobBoard.empty')
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('jobBoard.empty')), 1)
        ]))
  ]))
}